module.exports = __webpack_public_path__ + "static/img/blog 1680x1050.318fd1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/blog/blog 1680x1050.jpg
// module id = vCYu
// module chunks = 47